define(
	'Digi.Marketing.Marketing'
,   [
		'Digi.Marketing.Marketing.Router',
		'Utils'
	]
,   function (
		DigiMarketingMarketingRouter,
		Utils
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var userRole, profile, userRoleId, environment, config, validRoles, menuTitle, menuIndex;
			var validRolesArray = new Array();
			try {
				profile = require('Profile.Model');
				userRole = profile.getInstance();
				userRoleId = userRole.attributes.userRole;

				environment = container.getComponent('Environment');
				config = environment.getConfig('digiConfigSettings');
				validRoles = config && config.MarketingHub && config.MarketingHub.validroles;

				menuIndex = config && config.MarketingHub && config.MarketingHub.menuindex;
				menuIndex = menuIndex ? menuIndex : 1;

				menuTitle = config && config.MarketingHub && config.MarketingHub.menutitle;
				menuTitle = menuTitle ? menuTitle : 'Marketing Hub';

				if(validRoles) {
					validRolesArray = validRoles.split(',');
				}
			} catch(e) {

			}

			if(userRoleId && validRolesArray && validRolesArray.length > 0) {
				var validRoleFound = validRolesArray.filter(function(el){return el == userRoleId});
				if(validRoleFound && validRoleFound.length > 0) {

		            var MyAccountMenu = container.getComponent('MyAccountMenu');
		            var marketingassetgroup = {
		                id: 'Marketing',
		                name: Utils.translate(menuTitle),
						url: 'marketingHub',
		                index: menuIndex
		            }
		            MyAccountMenu.addGroup(marketingassetgroup);

					/*var PartnerPortalEntry = {
						id: 'partnerportal'
						, groupid: 'Marketing'
						, index: 1
						, url: 'marketingHub'
						, name: Utils.translate(menuTitle)
					}
					MyAccountMenu.addGroupEntry(PartnerPortalEntry);*/

					return new DigiMarketingMarketingRouter(container);

				}
			}

		}
	};
});
